import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {PersonLogin, RoleName} from '../person/person-login';
import {OrganizationService} from '../services/organization-service';
import {PersonLoginService} from '../services/person-login-service';
import {StringUtils} from '../utils/string-utils';
import {OrgUnitHeader} from './org-unit-header';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {FormsModule} from '@angular/forms';

@Component({
    selector: 'org-unit-master',
    templateUrl: './org-unit-master.component.html',
    styleUrls: ['./org-unit-master.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatProgressSpinner, RouterLink]
})
export class OrgUnitMasterComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly organizationService = inject(OrganizationService);
  private readonly router = inject(Router);


  public personLogin!: PersonLogin;
  public readonly searchResults = signal<OrgUnitHeader[]>(undefined!);
  public searchTerm!: string;
  public readonly isBusy = signal<boolean>(undefined!);
  public readonly errorMessage = signal<string>(undefined!);
  public readonly searchComplete = signal<boolean>(undefined!);

  public newOrganization(): void {
    this.router.navigate(['organization/new']);
  }

  public search(): void {
    if (!this.isBusy() && this.searchTerm && this.searchTerm.length >= 3) {
      this.clearStatus();
      this.organizationService.search(this.searchTerm).subscribe(results => {
        this.searchResults.set(results);
        this.isBusy.set(false);
        this.searchComplete.set(true);
      }, error => this.handleError(error));
    }
  }

  public handleKeyUp(keyEvent: any): void {
    if (keyEvent.keyCode === 13) {
      this.search();
    }
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.searchComplete.set(false);
    this.searchResults.set(null!);
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  public userHasRole(roleName: string) {
    return this.personLoginService.hasRole(RoleName[roleName as keyof typeof RoleName]);
  }

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      if (this.personLogin.person && this.personLogin.person.primaryOrgUnitId && this.personLogin.person.primaryOrgUnitId.length > 0) {
        this.searchTerm = this.personLogin.person.primaryOrgUnitId;
        this.search();
      }
    }
  }

}
